import React from 'react';
import functions from '../../util/functions';

const TrainerCard = ({trainer}) => {
    return (
        <div className="position-relative card shadow-sm d-flex flex-row align-items-center p-3" style={{ minWidth: '360px', maxWidth:'400px', borderRadius: '16px', overflow: 'hidden' }}>

        {/* Left Column: Trainer Info */}
        <div className="flex-grow-1 pr-3">
          <h6 className="font-weight-bold mb-1">{trainer.full_name}</h6>
          <small className="text-muted d-block mb-2 text-truncate" style={{ maxWidth: '80%' }}>{trainer.specialization}</small>

          <div className="mb-2">
            <i className="fa fa-phone text-muted mr-2"></i>
            <small>{trainer.phone_number}</small>
          </div>

          <div className="widget-subheading opacity-10 mb-2">
            <span><b className="text-success">UGX { functions.numberFormat(trainer.commission_balance)}</b> Commission</span>
          </div>

          {/* Stats Row */}
          <div className="d-flex" style={{ gap: '1rem' }}>
            <div className="card bg-light p-2 text-center" style={{ minWidth: '100px' }}>
              <div className="font-weight-bold text-primary">{trainer.classes_this_month}</div>
              <small className="text-muted">This Month</small>
            </div>
            <div className="card bg-light p-2 text-center" style={{ minWidth: '100px' }}>
              <div className="font-weight-bold text-dark">{trainer.total_classes}</div>
              <small className="text-muted">Total Classes</small>
            </div>
          </div>
        </div>

        {/* Right Column: Trainer Image */}
        <div className="text-center">
          <img
            src={trainer.photo}
            alt="avatar"
            className="rounded-circle"
            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
          />
        </div>

        {/* Top-right Expand Button */}
        <div className="position-absolute" style={{ top: '10px', right: '10px' }}>
          <button className="btn btn-light btn-sm rounded-circle shadow-sm">
            <i className="fa fa-expand-arrows-alt"></i>
          </button>
        </div>

      </div>
    );
};

export default TrainerCard;